module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-bg-2-f4cd95c3f05aed89c8ffd7ac020928bf.png";